<script lang="ts">
	export let href:string = ""
</script>

<a {href} target="_blank" rel="noopener noreferrer"><slot/></a>